import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { jtbCwtPageMeta, jtbCwtSchema } from 'components/common/schema'
import Template from 'components/cases/jtb-cwt'

const JtbCwt: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.add('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...jtbCwtPageMeta} />
      <JsonLd data={jtbCwtSchema} />
      <Template />
    </>
  )
}

export default JtbCwt
